export const loanPurposeListItem = ["Medical Emergency", "Salary Delay", "Personal Emergency", "Education", "Rent / Bills", "Others"];

export const ORDER_ID_LOCAL_STORAGE_KEY =  'orderId';

export const START_FINBOX_FLOW_LOCAL_KEY = "start_finbox_flow";

export const MONTH_12_FLAGS_STATUS = {
  APPROVED: "Approved",
  NOT_ELIGIBLE: "Not Eligible",
  PROCEED_TO_BANK: "Proceed to Bank",
};

export const IS_PERSONAL_LOAN_SELECTED = "is_personal_loan_selected"; // localStorage key to track if personal loan is selected
export const PREVIOUS_ROUTE_LOCAL_STORAGE_KEY = 'previous_route';

export const PAYMENT_RESPONSE_LOCAL_STORAGE_KEY = 'payment_response';

export const PAYMENT_GATEWAY = {
  ROZAR_PAY: 'razorpay',
  PAYU: "payu",
};

export const paymentStatusEnum = {
  SUCCESS: 'success',
  FAILURE: 'failed',
  PENDING: 'pending',
};

export const SELECTED_PAYMENT_GATEWAY = 'selected_payment_gateway';

export const MONTHLY_INCOME_CONSENT_TEXT = <>I confirm that my annual household income is <strong>more than ₹3,00,000,</strong> and the information provided is true and correct.</>;

export const EMI_PLAN_LOCAL_STORAGE_KEY = 'emi_plan';
export const OFFER_TYPE_LOCAL_STORAGE_KEY = 'offer_type';
export const SELECTED_PRADUCT_TYPE_ID_LOCAL_STORAGE_KEY = 'selected_product_type_id';
